import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

//export default new Router({
export const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/inicio",
      name: "inicio",
      component: () => import("./pages/inicio.vue"),
    },
    {
      path: "/punto-de-interes/:id",
      name: "puntodeinteres",
      component: () => import("./pages/concreteHito.vue"),
    },
    {
      path: "/noticias",
      name: "noticias",
      component: () => import("./pages/news.vue"),
    },
    {
      path: "/news/:id",
      name: "newsConcreto",
      component: () => import("./pages/concreteNew.vue"),
    },
    {
      path: "/hitos/:id",
      name: "hitos",
      component: () => import("./pages/hitos.vue"),
    },
    {
      path: "/rutas/:id",
      name: "rutaConcreto",
      component: () => import("./pages/concreteRuta.vue"),
    },
    // Ruta para Turismo accesible
    {
      path: "/turismo-accesible",
      name: "turismo-accesible",
      component: () => import("./pages/turismoAccesible.vue"),
    },
    // Rutas para Descubre
    {
      path: "/lugares",
      name: "lugares",
      component: () => import("./pages/lugares.vue"),
    },
    {
      path: "/mapa",
      name: "mapa",
      component: () => import("./pages/mapPage.vue"),
    },
    {
      path: "/pdi",
      name: "pdi",
      component: () => import("./pages/pdi.vue"),
    },
    {
      path: "/rutas",
      name: "rutas",
      component: () => import("./pages/rutas.vue"),
    },
    {
      path: "/rutas/:id",
      name: "rutasConcreto",
      component: () => import("./pages/concreteRuta.vue"),
    },

    // Rutas para Disfruta
    {
      path: "/callejeros",
      name: "callejeros",
      component: () => import("./pages/callejeros.vue"),
    },
    {
      path: "/curiosidades",
      name: "curiosidades",
      component: () => import("./pages/curiosidades.vue"),
    },
    {
      path: "/descarga",
      name: "descarga",
      component: () => import("./pages/descarga.vue"),
    },
    {
      path: "/enlaces",
      name: "enlaces",
      component: () => import("./pages/enlaces.vue"),
    },
    {
      path: "/eventos",
      name: "eventos",
      component: () => import("./pages/eventos.vue"),
    },
    // Rutas para Planifica
    {
      path: "/oficina",
      name: "oficina",
      component: () => import("./pages/oficina.vue"),
    },
    {
      path: "/dormir",
      name: "dormir",
      component: () => import("./pages/dormir.vue"),
    },
    {
      path: "/dormir/:id",
      name: "dormirConcreto",
      component: () => import("./pages/concreteDormir.vue"),
    },
    {
      path: "/comer",
      name: "comer",
      component: () => import("./pages/comer.vue"),
    },
    {
      path: "/comer/:id",
      name: "comerConcreto",
      component: () => import("./pages/concreteComer.vue"),
    },
    {
      path: "/actividades",
      name: "actividades",
      component: () => import("./pages/actividades.vue"),
    },
    {
      path: "/tarjeta",
      name: "tarjeta",
      component: () => import("./components/Tarjeta.vue"),
    },
    {
      path: "/grafica",
      name: "grafica",
      component: () => import("./components/Grafica.vue"),
    },
    {
      path: "/*",
      redirect: "/inicio",
    },
  ],
});
